import React, { useContext, useState } from "react";
import {
  Grid,
  Paper,
  Avatar,
  TextField,
  Checkbox,
  FormControlLabel,
  Button,
  Typography,
  Link,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import AuthContext from "../components/AuthContext";

const Login = ({ handleChange, handleClose }) => {
  const paperStyle = {
    padding: 30,
    height: "auto",
    width: 356,
    margin: "0 auto",
  };

  const [open, setOpen] = useState(false);
  const { isLoggedIn, setIsLoggedIn } = useContext(AuthContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const avatarStyle = { backgroundColor: "#f5f109" };
  const btnstyle = { margin: "8px 0" };

  const handleLogin = () => {
    localStorage.setItem("username", username);
    localStorage.setItem("password", password);
    setIsLoggedIn(true);
    handleClose();
  };

  return (
    <Grid>
      <Paper elevation={10} style={paperStyle}>
        <Grid align="center">
          <Avatar style={avatarStyle}>
            <LockIcon />
          </Avatar>
          <h2>Logg Inn</h2>
        </Grid>
        <TextField
          variant="standard"
          label="Brukernavn"
          placeholder="Skriv brukernavn"
          fullWidth
          required
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <TextField
          variant="standard"
          label="Passord"
          placeholder="Skriv passord"
          type="password"
          fullWidth
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />{" "}
        <FormControlLabel
          control={<Checkbox name="checkedB" color="primary" />}
          label="Husk meg"
        />
        <Button
          type="submit"
          color="primary"
          variant="contained"
          style={btnstyle}
          fullWidth
          onClick={handleLogin}
        >
          Log Inn
        </Button>
        <Button
          color="secondary"
          variant="contained"
          style={btnstyle}
          fullWidth
          onClick={handleClose}
        >
          Avbryt
        </Button>
        <Typography>
          <Link href="#" color="primary">
            {"Glemte passord?"}
          </Link>
        </Typography>
        <Typography>
          {"Har du en konto? "}
          <Link
            href="http://localhost:3000/Signup"
            onClick={() => handleChange("event", 1)}
            color="primary"
          >
            {"Registrer"}
          </Link>
        </Typography>
      </Paper>
    </Grid>
  );
};

export default Login;
